/**
 * Adventure/Tour Schema Component
 * From SchemaMarkup.tsx lines 289-344
 * Enhanced as TouristAttraction for AI discovery
 */

import { BASE_URL } from '@/lib/constants';
import type { AdventureSchemaProps } from './types';

export function AdventureSchema({
  name,
  description,
  image,
  url,
  activityType,
  location,
  geo,
}: AdventureSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'TouristAttraction',
    '@id': `${BASE_URL}${url}#attraction`,
    name,
    description,
    image: image.startsWith('http') ? image : `${BASE_URL}${image}`,
    url: `${BASE_URL}${url}`,
    touristType: ['Adventure Traveler', 'Ski Enthusiast', 'Luxury Traveler', activityType],
    geo: geo
      ? {
          '@type': 'GeoCoordinates',
          latitude: geo.latitude,
          longitude: geo.longitude,
        }
      : {
          '@type': 'GeoCoordinates',
          latitude: -33.35,
          longitude: -70.25,
        },
    isAccessibleForFree: false,
    publicAccess: false,
    availableLanguage: ['English', 'Spanish'],
    openingHours: 'Mo-Su 07:00-18:00',
    provider: {
      '@id': `${BASE_URL}/#organization`,
    },
    ...(location && {
      containedInPlace: {
        '@type': 'Place',
        name: location,
      },
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
